// extracted by mini-css-extract-plugin
export default {"buttonChatIA":"ButtonChatIA_buttonChatIA__KARZt","animation-buttonChatIA":"ButtonChatIA_animation-buttonChatIA__M8tzj"};